import {gsap} from "gsap";
import {DrawSVGPlugin} from "gsap/DrawSVGPlugin"

gsap.registerPlugin(DrawSVGPlugin)

window.addEventListener("DOMContentLoaded", () => {
    const arrow = document.querySelector<HTMLElement>('.WheelOfTasksComponent #svg-line')
    const select = document.querySelector<HTMLElement>('.WheelOfTasksComponent #selectName')

    if (arrow) {
        const tl = gsap.timeline({
            paused: true, ease: "none",
        });

        tl.fromTo(arrow, {
            drawSVG: "0% 100%",
        }, {
            drawSVG: "100% 100%",
            immediateRender: false,
        });
        tl.fromTo(arrow, {
            drawSVG: "0%",
        }, {
            drawSVG: "100%",
            immediateRender: false,
        });


        select.addEventListener("pointerenter", () => {
            tl.play(0);
        })
    }
});